import { render } from "./AlbumsSection.vue?vue&type=template&id=1151b678&scoped=true"
import script from "./AlbumsSection.vue?vue&type=script&lang=js"
export * from "./AlbumsSection.vue?vue&type=script&lang=js"

import "./AlbumsSection.vue?vue&type=style&index=0&id=1151b678&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1151b678"]])

export default __exports__